import { useWhatsappNotifications } from "../WebSocketNotification";
import { WebsocketBaseUrl } from "../../../Config/baseUrl";
import { websocket_Url } from "../../../Config/urls";
import { useCallback } from "react";
import { useProfile } from "../../../Settings";

const WebSocketListeners = () => {
  const { data } = useProfile();

  const storeId = data?.data?.store_id;
  const Email = data?.data?.user_name;
  const allowedRoles = ["Store Admin"];

  const formatWhatsappNotification = useCallback(
    (raw) => ({
      message: raw?.message || "",
      type: raw?.message_type,
      phoneNumber: raw?.phoneNumber || null,
      Business_id: raw?.Business_id || null,
      redirect: "/chat",
    }),
    [],
  );

  const formatTicketBookingNotification = useCallback(
    (raw) => ({
      message: raw?.message || "",
      type: raw?.message_type,
      redirect: "/support/tickets",
    }),
    [],
  );

  const formatServiceBookingNotification = useCallback(
    (raw) => ({
      message: raw?.message || "",
      type: raw?.message_type,
      redirect: "/support/booking",
    }),
    [],
  );

  const formatSalesOrderNotification = useCallback(
    (raw) => ({
      message: raw?.message || "",
      type: raw?.message_type,
      redirect: "/sales/sales-orders",
    }),
    [],
  );

  const formatPosOrderNotification = useCallback(
    (raw) => ({
      message: raw?.message || "",
      type: raw?.message_type,
      redirect: "/pos/website-orders",
    }),
    [],
  );

  const formatLowStockNotification = useCallback(
    (raw) => ({
      message: raw?.message || "",
      type: raw?.message_type,
    }),
    [],
  );

  const formatLeaveApplyNotification = useCallback(
    (raw) => ({
      message: raw?.message || "",
      type: raw?.message_type,
      redirect: "/hrm/leave-application",
    }),
    [],
  );

  const formatLeaveNotification = useCallback(
    (raw) => ({
      message: raw?.message || "",
      type: raw?.message_type,
      redirect: "/hrm/leave-application",
    }),
    [],
  );

  const formatLeadNotification = useCallback(
    (raw) => ({
      message: raw?.message || "",
      type: raw?.message_type,
      redirect: "/crm/lead",
    }),
    [],
  );

  const formatFollowUpNotification = useCallback(
    (raw) => ({
      message: raw?.message || "",
      type: raw?.message_type,
      redirect: "/crm/lead",
    }),
    [],
  );

  const formatInternalChatNotification = useCallback((raw) => {
    console.log(raw, "sdjdf");
    return {
      message: raw?.message || "",
      sender: raw?.sender,
      type: raw?.message_type,
      redirect: "/chat-agent",
    };
  }, []);

  //   const formatInternalChatNotification = useCallback(
  //     (raw) => ({
  //       message: raw?.message || "",
  //       sender: raw?.sender,
  //       type: raw?.message_type,
  //       redirect: "/internal-chat",
  //     }),
  //     []
  //   )

  //   const formatAutoReplyInternalChatNotification = useCallback(
  //     (raw) => ({
  //       message: raw?.message || "",
  //       sender: raw?.sender,
  //       type: raw?.message_type,
  //       redirect: "/internal-chat",
  //     }),
  //     []
  //   )

  const formatInterviewNotification = useCallback(
    (raw) => ({
      message: raw?.message || "",
      type: raw?.message_type,
      redirect: "/hrm/interview",
    }),
    [],
  );

  const formatNewCandidateInterviewNotification = useCallback(
    (raw) => ({
      message: raw?.message || "",
      type: raw?.message_type,
      redirect: "/hrm/hiring",
    }),
    [],
  );

  const notificationRouter = useCallback((raw) => {
    const type = raw?.message_type;

    const common = {
      message: raw?.message || "",
      type: type,
    };

    switch (type) {
      case "Whatsapp Message":
        return {
          ...common,
          phoneNumber: raw?.phoneNumber || null,
          Business_id: raw?.Business_id || null,
          redirect: "/chat",
        };
      case "New Ticket":
        return { ...common, redirect: "/support/tickets" };
      case "New Service Book":
        return { ...common, redirect: "/support/booking" };
      case "New Sales Order":
        return { ...common, redirect: "/sales/sales-orders" };
      case "New Pos Order":
        return { ...common, redirect: "/pos/website-orders" };
      case "Low Stock Alert":
        return common;
      case "New Leave Request":
      case "leave":
        return { ...common, redirect: "/hrm/leave-application" };
      case "New Lead":
      case "Lead Followup":
        return { ...common, redirect: "/crm/lead" };

      case "Interview Feedback":
        return { ...common, redirect: "/hrm/interview" };
      case "New Candidate":
        return { ...common, redirect: "/hrm/hiring" };

      case "Chat Auto Reply":
        if (
          raw?.message_type === "Chat Auto Reply" &&
          !allowedRoles.includes(localStorage.getItem("role"))
        ) {
          return null;
        }
        return {
          message: raw?.message || "",
          sender: raw?.sender,
          type: raw?.message_type,
          redirect: "/internal-chat",
        };
      default:
        return common;
    }
  }, []);

  useWhatsappNotifications(
    data?.data
      ? `${WebsocketBaseUrl}${websocket_Url.all_notification}${storeId}/`
      : null,
    formatInternalChatNotification,
  );

  useWhatsappNotifications(
    data?.data
      ? `${WebsocketBaseUrl}${websocket_Url.internal_chat_notification}${Email}/`
      : null,
    formatInternalChatNotification,
  );

  //   useWhatsappNotifications(
  //     profile ? `${WebsocketBaseUrl}${websocket_Url.internal_chat_notification}${Email}/` : null,
  //     formatAutoReplyInternalChatNotification
  //   )

  return null;
};

export default WebSocketListeners;
